require('../../modules/core.regexp.escape');
module.exports = require('../../modules/_core').RegExp.escape;



// WEBPACK FOOTER //
// ./C:/Users/Pili/AppData/Roaming/npm/~/pink/~/core-js/fn/regexp/escape.js